import PageTemplate from 'components/template/PageTemplate';
import { ReactComponent as Warn } from 'assets/sales/warn.svg'

const Sales = () => {
    return (
        <PageTemplate>
            <div className='flex flex-col justify-center items-center gap-10 h-dvh'>
                <Warn />
                <div className='flex flex-col items-center gap-6 font-semibold'>
                    <p className='text-40'>해당 메뉴 이용 권한이 없습니다.</p>
                    <p className='text-2xl'>관련 문의는 <span className='text-primary'>help@theinsiht.co.kr</span>로 문의 바랍니다.</p>
                </div>
            </div>
        </PageTemplate>
    )
}

export default Sales